export default {
  title: "فرم سفارش",
  detail: "ایجاد یا ویرایش سفارش برای مشتریان",
  back: "بازگشت",
  saving: "در حال ذخیره...",
  save: "ذخیره",
  success: "عملیات موفق",
  error: "خطا",
  networkError: "خطای شبکه",

  customer: "مشتری",
  placeholderCustomer: "جستجوی مشتری (نام یا شماره موبایل)",
  status: "وضعیت سفارش",
  statusRegistered: 'ثبت شده',
  statusApproved: 'تایید شده',
  statusRejected: 'رد شده',

  shippingMethod: "روش ارسال",
  placeholderShippingMethod: "انتخاب روش ارسال",
  paymentMethod: "روش پرداخت",
  placeholderPaymentMethod: "انتخاب روش پرداخت",
  address: "آدرس",
  selectAddress: "آدرس را انتخاب کنید",
  addressDetails: "جزئیات آدرس",
  addressTitle: "عنوان آدرس",
  addressPhone: "تلفن آدرس",
  postalCode: "کد پستی",
  fullAddress: "آدرس کامل",
  addressExtraDetails: "جزئیات بیشتر",
  emptyAddress: "آدرس بدون اطلاعات",

  items: "کالاها",
  addItem: "افزودن کالا",
  product: "محصول",
  placeholderProduct: "جستجوی محصول (نام)",
  quantity: "تعداد",
  price: "قیمت واحد",
  subtotal: "جمع جزء",
  discount: "تخفیف",
  itemDiscount: "تخفیف دستی",
  discountPaymentMethod: "تخفیف روش پرداخت",
  shippingCost: "هزینه ارسال",
  tax: "مالیات",
  summary: "خلاصه فاکتور",
  totalDiscount: "مجموع تخفیف‌ها",
  totalPrice: "مبلغ نهایی",
  total: "جمع",
  calculating: "در حال محاسبه فاکتور...",
};
